import React from 'react'

import type { useInternalState } from './hooks/useInternalState'

type Internals = ReturnType<typeof useInternalState>

export type InterviewState = Internals['state']
export type InterviewHandlers = Internals['handlers']

export const InterviewHandlersContext = React.createContext<
  InterviewHandlers | undefined
>(undefined)
export const InterviewStateContext = React.createContext<
  InterviewState | undefined
>(undefined)
